import api from "./api";

// Permission Management
const getAllAdminsWithPermissions = async () => {
  const response = await api.get("/admin-permissions/admins");
  return response.data;
};

const updateAdminPermissions = async (adminId, permissions) => {
  const response = await api.put(`/admin-permissions/admin/${adminId}`, {
    adminId,
    permissions,
  });
  return response.data;
};

const applyPresetRole = async (adminId, rolePreset) => {
  const response = await api.post(
    `/admin-permissions/admin/${adminId}/preset`,
    {
      adminId,
      rolePreset,
    }
  );
  return response.data;
};

const getPermissionTemplates = async () => {
  const response = await api.get("/admin-permissions/templates");
  return response.data;
};

const checkPermission = async (module, action, context = {}) => {
  const response = await api.post("/admin-permissions/check", {
    module,
    action,
    context,
  });
  return response.data;
};

// Approval Management
const getPendingApprovals = async () => {
  const response = await api.get("/admin-permissions/approvals");
  return response.data;
};

const approveRequest = async (approvalId, comments) => {
  const response = await api.post("/admin-permissions/approve", {
    approvalId,
    comments,
  });
  return response.data;
};

const rejectRequest = async (approvalId, reason) => {
  const response = await api.post("/admin-permissions/reject", {
    approvalId,
    reason,
  });
  return response.data;
};

const getApprovalHistory = async (filters = {}) => {
  const response = await api.get("/admin-permissions/approvals/history", {
    params: filters,
  });
  return response.data;
};

const createApprovalRequest = async (requestData) => {
  const response = await api.post(
    "/admin-permissions/approvals/create",
    requestData
  );
  return response.data;
};

const permissionService = {
  // Permission operations
  getAllAdminsWithPermissions,
  updateAdminPermissions,
  applyPresetRole,
  getPermissionTemplates,
  checkPermission,

  // Approval operations
  getPendingApprovals,
  approveRequest,
  rejectRequest,
  getApprovalHistory,
  createApprovalRequest,
};

export default permissionService;
